// extracted by mini-css-extract-plugin
module.exports = {"bar":"_5D1ufPMc","description":"_5D3kMToe","list":"_5D3R2vaE","list__role":"_5D3WWcc2"};